import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
    CreateFlow,
    DeviceCode,
    DeviceCodeStatus,
    Flow,
    UpdateFlow,
} from '@myrtls/api-interfaces';

export const getFlowsAction = createAction('[Flows] Get Flows');

export const getFlowsSuccessAction = createAction(
    '[Flows] Get Flows Success',
    props<{ flows: Flow[] }>(),
);

export const getFlowsFailureAction = createAction(
    '[Flows] Get Flows Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const createFlowAction = createAction(
    '[Flows] Create Flow',
    props<{ flow: CreateFlow }>(),
);

export const createFlowSuccessAction = createAction(
    '[Flows] Create Flow Success',
);

export const createFlowFailureAction = createAction(
    '[Flows] Create Flow Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const updateFlowAction = createAction(
    '[Flows] Update Flow',
    props<{ flow: UpdateFlow }>(),
);

export const updateFlowSuccessAction = createAction(
    '[Flows] Update Flow Success',
);

export const updateFlowFailureAction = createAction(
    '[Flows] Update Flow Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const deleteFlowAction = createAction(
    '[Flows] Delete Flow',
    props<{ flowId: string }>(),
);

export const deleteFlowSuccessAction = createAction(
    '[Flows] Delete Flow Success',
);

export const deleteFlowFailureAction = createAction(
    '[Flows] Delete Flow Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const generateFlowDeviceCodeAction = createAction(
    '[Flows] Generate Flow Device Code',
    props<{ flowId: string }>(),
);

export const generateFlowDeviceCodeSuccessAction = createAction(
    '[Flows] Generate Flow Device Code Success',
    props<DeviceCode>(),
);

export const generateFlowDeviceCodeFailureAction = createAction(
    '[Flows] Generate Flow Device Code Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const startPollingCodeStatusAction = createAction(
    '[Flows] Start Polling Code Status',
    props<{ code: string; intervalTime: number }>(),
);

export const stopPollingCodeStatusAction = createAction(
    '[Flows] Stop Polling Code Status',
);

export const getCodeStatusAction = createAction(
    '[Flows] Get Code Status',
    props<{ code: string }>(),
);

export const getCodeStatusSuccessAction = createAction(
    '[Flows] Get Code Status Success',
    props<DeviceCodeStatus>(),
);

export const getCodeStatusFailureAction = createAction(
    '[Flows] Get Code Status Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const updateDeviceNoteAction = createAction(
    '[Flows] Update Device Note',
    props<{ deviceId: string; note: string | null }>(),
);

export const updateDeviceNoteSuccessAction = createAction(
    '[Flows] Update Device Note Success',
);

export const updateDeviceNoteFailureAction = createAction(
    '[Flows] Update Device Note Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const deleteDeviceAction = createAction(
    '[Flows] Delete Device',
    props<{ deviceId: string }>(),
);

export const deleteDeviceSuccessAction = createAction(
    '[Flows] Delete Device Success',
);

export const deleteDeviceFailureAction = createAction(
    '[Flows] Delete Device Failure',
    props<{ error: HttpErrorResponse }>(),
);
